import React from "react";
import ColorForm from "./form";
import ColorList from "./list";
import Column from "@components/column";

const ColorSetup = () => {
  return (
    <Column>
      <ColorForm />
      <ColorList />
    </Column>
  );
};

export default ColorSetup;
